import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import './Home.css';

const Home: React.FC = () => {
  return (
    <Layout>
      <div className="home-container">
        <main className="home-main">
        <section className="hero-section">
          <div className="hero-content">
            <h2 className="hero-title">Master Your Productivity with Pomodoro Technique</h2>
            <p className="hero-description">
              Track your focus time, analyze your productivity patterns, and achieve your goals with our powerful Pomodoro Timer application.
            </p>
            <div className="hero-actions">
              <Link to="/register" className="cta-button primary">
                Get Started Free
              </Link>
              <Link to="/login" className="cta-button secondary">
                Sign In
              </Link>
            </div>
          </div>
          <div className="hero-visual">
            <div className="timer-icon">⏰</div>
          </div>
        </section>

        <section className="features-section">
          <div className="container">
            <h3 className="section-title">Powerful Features to Boost Your Productivity</h3>
            <div className="features-grid">
              <div className="feature-card">
                <div className="feature-icon">🍅</div>
                <h4 className="feature-title">Pomodoro Timer</h4>
                <p className="feature-description">
                  Classic 25-minute focus sessions with built-in breaks to maintain maximum productivity and prevent burnout.
                </p>
              </div>
              <div className="feature-card">
                <div className="feature-icon">📊</div>
                <h4 className="feature-title">Analytics & Insights</h4>
                <p className="feature-description">
                  Detailed statistics and trends to understand your productivity patterns and optimize your work habits.
                </p>
              </div>
              <div className="feature-card">
                <div className="feature-icon">🎯</div>
                <h4 className="feature-title">Goal Tracking</h4>
                <p className="feature-description">
                  Set daily and weekly goals, track your progress, and celebrate your achievements along the way.
                </p>
              </div>
              <div className="feature-card">
                <div className="feature-icon">⚙️</div>
                <h4 className="feature-title">Customizable Settings</h4>
                <p className="feature-description">
                  Personalize your Pomodoro experience with custom session lengths, break times, and notification preferences.
                </p>
              </div>
              <div className="feature-card">
                <div className="feature-icon">🔗</div>
                <h4 className="feature-title">API Integration</h4>
                <p className="feature-description">
                  Connect your favorite tools and automate workflows with our comprehensive REST API and webhooks.
                </p>
                <div className="feature-link">
                  <a
                    href="/api-docs"
                    className="api-docs-link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    View API Docs →
                  </a>
                </div>
              </div>
              <div className="feature-card">
                <div className="feature-icon">📱</div>
                <h4 className="feature-title">Cross-Platform</h4>
                <p className="feature-description">
                  Access your timer and data from any device with our responsive web application that works everywhere.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="workflow-section">
          <div className="container">
            <h3 className="section-title">How It Works</h3>
            <div className="workflow-steps">
              <div className="step">
                <div className="step-number">1</div>
                <div className="step-content">
                  <h4 className="step-title">Create Account</h4>
                  <p className="step-description">Sign up in seconds and start your productivity journey</p>
                </div>
              </div>
              <div className="step">
                <div className="step-number">2</div>
                <div className="step-content">
                  <h4 className="step-title">Start Timer</h4>
                  <p className="step-description">Begin a 25-minute focused work session</p>
                </div>
              </div>
              <div className="step">
                <div className="step-number">3</div>
                <div className="step-content">
                  <h4 className="step-title">Take Break</h4>
                  <p className="step-description">Enjoy a 5-minute break to recharge</p>
                </div>
              </div>
              <div className="step">
                <div className="step-number">4</div>
                <div className="step-content">
                  <h4 className="step-title">Track Progress</h4>
                  <p className="step-description">Monitor your productivity and achieve your goals</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="cta-section">
          <div className="container">
            <div className="cta-content">
              <h3 className="cta-title">Ready to Transform Your Productivity?</h3>
              <p className="cta-description">
                Join thousands of users who have already improved their focus and achieved more with the Pomodoro Technique.
              </p>
              <div className="cta-actions">
                <Link to="/register" className="cta-button primary large">
                  Start Free Today
                </Link>
              </div>
            </div>
          </div>
        </section>
        </main>
      </div>
    </Layout>
  );
};

export default Home;